import { getUploadedTime } from 'SupplierDiversity/utils';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getClientDataUploadHistory } from 'utils/apiRequests';

const ClientDataUploadHistory = createContext();

function sentenceCase(str) {
	if (str === null || str === '') return false;
	else str = str.toString();

	return str.replace(/\w\S*/g, function(txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
}

export const ClientDataUploadHistoryProvider = ({ children }) => {
	const [isHistoryFetching, setIisHistoryFetching] = useState(false);
	const [uploadedList, setUploadedList] = useState([]);

	useEffect(
		() => {
			getHistoryData();
		}, // eslint-disable-next-line
		[]
	);

	const getHistoryData = async () => {
		setIisHistoryFetching(true);
		const response = await getClientDataUploadHistory();
		if (response.succeeded) {
			if (response.data !== null && response.data.length > 0) {
				const rowResult = response.data.sort((a, b) => b.id - a.id).map(el => {
					return {
						author_name: el.author_name,
						status: sentenceCase(el.status),
						published_time: getUploadedTime(el.published_time),
					};
				});
				setUploadedList(rowResult);
			}
			setIisHistoryFetching(false);
		} else {
			setIisHistoryFetching(false);
		}
	};

	return (
		<ClientDataUploadHistory.Provider
			value={{
				isHistoryFetching,
				uploadedList,
				getHistoryData,
			}}
		>
			{children}
		</ClientDataUploadHistory.Provider>
	);
};

export const useClientDataUploadHistoryContext = () => {
	return useContext(ClientDataUploadHistory);
};
